import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useAuth } from '../pages/AuthContext';
import "../styles/Customer.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faBox,
    faBarcode,
    faTag,
    faBuilding,
    faBalanceScale,
    faDollarSign,
    faCalculator,
    faExclamationTriangle,
    faCalendarAlt,
    faSave,
    faTimes,
    faSpinner,
    faCheckCircle,
    faStore,
    faExchangeAlt,
    faWarehouse,
    faPercent,
    faLayerGroup
} from '@fortawesome/free-solid-svg-icons';

// Create translator instance with Urdu translations
const createProductsTranslator = () => {
    let cache = new Map();
    
    // Predefined translations for Urdu (to ensure they work)
    const urduTranslations = {
        // Form headers
        addProduct: 'محفوظ کریں',
        editProduct: 'ترمیم کریں',
        fillDetails: 'براہ کرم تفصیلات درج کریں',
        productDetails: 'مصنوعات کی تفصیلات',
        
        // Field labels
        productName: 'مصنوعات کا نام',
        batchNumber: 'بیچ نمبر',
        barcode: 'بارکوڈ',
        category: 'زمرہ',
        company: 'کمپنی / برانڈ',
        unit: 'یونٹ',
        costPrice: 'لاگت قیمت',
        sellingPrice: 'فروخت قیمت',
        quantity: 'مقدار',
        quantityAlert: 'کم اسٹاک الرٹ',
        expiryDate: 'میعاد ختم ہونے کی تاریخ',
        date: 'تاریخ',
        stockCategory: 'اسٹاک کی قسم',
        
        // Stock category options
        saleable: 'قابل فروخت',
        raw: 'خام مال',
        
        // Buttons
        addProductButton: 'محفوظ کریں',
        updateProduct: 'اپ ڈیٹ کریں',
        clearButton: 'صاف کریں',
        
        // Status messages
        adding: 'محفوظ ہو رہا ہے...',
        updating: 'اپ ڈیٹ ہو رہا ہے...',
        productSaved: 'مصنوعات کامیابی سے محفوظ ہو گئی!',
        productUpdated: 'مصنوعات کامیابی سے اپ ڈیٹ ہو گئی!',
        failedAdd: 'مصنوعات محفوظ کرنے میں ناکامی',
        failedUpdate: 'مصنوعات اپ ڈیٹ کرنے میں ناکامی',
        networkError: 'نیٹ ورک کی خرابی',
        
        // Validation messages
        nameRequired: 'مصنوعات کا نام ضروری ہے',
        nameTooShort: 'نام کم از کم 2 حروف کا ہونا چاہیے',
        batchRequired: 'بیچ نمبر ضروری ہے',
        batchExists: 'یہ بیچ نمبر پہلے سے موجود ہے',
        unitRequired: 'یونٹ ضروری ہے',
        costPriceRequired: 'لاگت قیمت ضروری ہے',
        sellingPriceRequired: 'فروخت قیمت ضروری ہے',
        quantityRequired: 'مقدار ضروری ہے',
        alertRequired: 'کم اسٹاک الرٹ ضروری ہے',
        invalidPrice: 'براہ کرم درست قیمت درج کریں',
        invalidQuantity: 'براہ کرم درست مقدار درج کریں',
        expiryPast: 'میعاد ختم ہونے کی تاریخ ماضی میں نہیں ہو سکتی',
        dateInvalid: 'براہ کرم درست تاریخ منتخب کریں',
        
        // Toast messages
        success: 'کامیابی',
        error: 'خرابی',
        warning: 'انتباہ',
        
        // Shop related
        selectShop: 'پہلے دکان منتخب کریں',
        currentShop: 'موجودہ دکان',
        willAddToShop: 'مصنوعات اس دکان میں شامل ہو گی',
        noShopSelected: 'کوئی دکان منتخب نہیں۔ براہ کرم پہلے دکان تبدیل کریں',
        switchShop: 'دکان تبدیل کریں',
        shopSwitched: 'دکان کامیابی سے تبدیل ہو گئی',
        shopSwitchFailed: 'دکان تبدیل کرنے میں ناکامی',
        noShopPermission: 'آپ کو اس دکان میں مصنوعات شامل کرنے کی اجازت نہیں ہے',
        loadingShops: 'دکانیں لوڈ ہو رہی ہیں...',
        noShops: 'کوئی دکان دستیاب نہیں',
        active: 'فعال',
        current: 'موجودہ',
        
        // Calculations
        profitMargin: 'منافع کا مارجن',
        markup: 'مارک اپ',
        
        // Categories
        selectstockCategory: 'زمرہ منتخب کریں',
        selectCategory: 'زمرہ منتخب کریں',
        medicine: 'دوائی',
        grocery: 'گروسری',
        electronics: 'الیکٹرانکس',
        clothing: 'کپڑے',
        cosmetics: 'کاسمیٹکس',
        other: 'دیگر',
        
        // Units
        selectUnit: 'یونٹ منتخب کریں',
        piece: 'ٹکڑا',
        box: 'ڈبہ',
        packet: 'پیکٹ',
        kg: 'کلوگرام',
        gram: 'گرام',
        liter: 'لیٹر',
        ml: 'ملی لیٹر',
        dabba: 'ڈبہ',
        borai: 'بوری',
        dozen: 'درجن',
        
        // Optional indicator
        optional: 'اختیاری',
        
        // Placeholders
        enterProductName: 'مصنوعات کا نام درج کریں',
        enterBatchNumber: 'بیچ نمبر درج کریں',
        barcodeAutoGenerate: 'بارکوڈ خودکار جنریٹ ہو گا',
        enterCompany: 'کمپنی/برانڈ درج کریں',
        zeroPlaceholder: '0.0',
        zeroPlaceholderDecimal: '0.00',
        zeroPlaceholderThreeDecimal: '0.000'
    };

    const loadFromCache = () => {
        try {
            const cached = localStorage.getItem('ourzest_translations');
            if (cached) {
                const parsed = JSON.parse(cached);
                Object.entries(parsed).forEach(([key, value]) => {
                    cache.set(key, value);
                });
            }
        } catch (e) {
            console.log("No cache found");
        }
    };

    const saveToCache = () => {
        try {
            const cacheObj = {};
            cache.forEach((value, key) => {
                cacheObj[key] = value;
            });
            localStorage.setItem('ourzest_translations', JSON.stringify(cacheObj));
        } catch (e) {
            console.error("Error saving to cache:", e);
        }
    };

    const translateAPI = async (text, targetLang) => {
        if (targetLang === 'en') return text;
        
        // Return Urdu translations directly from the object
        if (targetLang === 'ur') {
            // Find the key for this text
            for (const [key, value] of Object.entries(urduTranslations)) {
                if (value === text) {
                    return value;
                }
            }
            // If not found in reverse mapping, check if it's an English key
            if (urduTranslations[text]) {
                return urduTranslations[text];
            }
        }

        try {
            const response = await fetch('https://translate.argosopentech.com/translate', {
                method: 'POST',
                body: JSON.stringify({ q: text, source: 'en', target: targetLang }),
                headers: { 'Content-Type': 'application/json' }
            });

            if (response.ok) {
                const data = await response.json();
                return data.translatedText;
            }
        } catch (e) {
            console.log("LibreTranslate failed");
        }

        try {
            const response = await fetch(
                `https://api.mymemory.translated.net/get?q=${encodeURIComponent(text)}&langpair=en|${targetLang}`
            );
            if (response.ok) {
                const data = await response.json();
                return data.responseData.translatedText;
            }
        } catch (e) {
            console.log("MyMemory failed");
        }

        return text;
    };

    const translateText = async (text, targetLang) => {
        const cacheKey = `${text}_${targetLang}`;

        if (cache.has(cacheKey)) {
            return cache.get(cacheKey);
        }

        const translated = await translateAPI(text, targetLang);
        cache.set(cacheKey, translated);
        saveToCache();

        return translated;
    };

    const defaultTexts = {
        // Form headers
        addProduct: 'Save Product',
        editProduct: 'Edit Product',
        fillDetails: 'Fill in the product details below',
        productDetails: 'Product Details',
        
        // Field labels
        productName: 'Product Name',
        batchNumber: 'Batch Number',
        barcode: 'Barcode',
        category: 'Category',
        company: 'Company / Brand',
        unit: 'Unit',
        costPrice: 'Cost Price',
        sellingPrice: 'Selling Price',
        quantity: 'Quantity',
        quantityAlert: 'Low Stock Alert',
        expiryDate: 'Expiry Date',
        date: 'Date',
        stockCategory: 'Stock Category',
        
        // Stock category options
        saleable: 'Saleable',
        raw: 'Raw Material',
        
        // Buttons
        addProductButton: 'Save Product',
        updateProduct: 'Update Product',
        clearButton: 'Clear',
        
        // Status messages
        adding: 'Adding...',
        updating: 'Updating...',
        productSaved: 'Product saved successfully!',
        productUpdated: 'Product updated successfully!',
        failedAdd: 'Failed to save product',
        failedUpdate: 'Failed to update product',
        networkError: 'Network error occurred',
        
        // Validation messages
        nameRequired: 'Product name is required',
        nameTooShort: 'Name must be at least 2 characters',
        batchRequired: 'Batch number is required',
        batchExists: 'This batch number already exists',
        unitRequired: 'Unit is required',
        costPriceRequired: 'Cost price is required',
        sellingPriceRequired: 'Selling price is required',
        quantityRequired: 'Quantity is required',
        alertRequired: 'Low stock alert quantity is required',
        invalidPrice: 'Please enter a valid price',
        invalidQuantity: 'Please enter a valid quantity',
        expiryPast: 'Expiry date cannot be in the past',
        dateInvalid: 'Please select a valid date',
        
        // Toast messages
        success: 'Success',
        error: 'Error',
        warning: 'Warning',
        
        // Shop related
        selectShop: 'Select a shop first',
        currentShop: 'Current Shop',
        willAddToShop: 'Product will be added to this shop',
        noShopSelected: 'No shop selected. Please switch to a shop first.',
        switchShop: 'Switch Shop',
        shopSwitched: 'Shop switched successfully',
        shopSwitchFailed: 'Failed to switch shop',
        noShopPermission: 'You do not have permission to add products to this shop',
        loadingShops: 'Loading shops...',
        noShops: 'No shops available',
        active: 'Active',
        current: 'Current',
        
        // Calculations
        profitMargin: 'Profit Margin',
        markup: 'Markup',
        
        // Categories
        selectstockCategory: 'Stock category',
        selectCategory: 'Select category',
        medicine: 'Medicine',
        grocery: 'Grocery',
        electronics: 'Electronics',
        clothing: 'Clothing',
        cosmetics: 'Cosmetics',
        other: 'Other',
        food: 'Food',
        
        // Units
        selectUnit: 'Select unit',
        piece: 'Piece',
        box: 'Box',
        packet: 'Packet',
        kg: 'Kilogram',
        gram: 'Gram',
        liter: 'Liter',
        ml: 'Milliliter',
         dabba: 'ڈبہ ',
        borai: 'بوری',
        dozen: 'Dozen',
        
        // Optional indicator
        optional: 'Optional',
        
        // Placeholders
        enterProductName: 'Enter product name',
        enterBatchNumber: 'Enter batch number',
        barcodeAutoGenerate: 'Barcode will auto-generate',
        enterCompany: 'Enter company/brand',
        zeroPlaceholder: '0.0',
        zeroPlaceholderDecimal: '0.00',
        zeroPlaceholderThreeDecimal: '0.000'
    };

    const getTranslations = async (lang) => {
        if (lang === 'en') {
            return defaultTexts;
        }
        
        // For Urdu, return predefined translations immediately
        if (lang === 'ur') {
            return urduTranslations;
        }

        const translations = {};
        const promises = [];

        Object.keys(defaultTexts).forEach(key => {
            const cacheKey = `${defaultTexts[key]}_${lang}`;
            if (cache.has(cacheKey)) {
                translations[key] = cache.get(cacheKey);
            } else {
                promises.push(
                    translateText(defaultTexts[key], lang).then(translated => {
                        translations[key] = translated;
                    })
                );
            }
        });

        if (promises.length > 0) {
            await Promise.all(promises);
            saveToCache();
        }

        return translations;
    };

    loadFromCache();

    return {
        getTranslations,
        translateText
    };
};

const productsTranslator = createProductsTranslator();

// Toast Notification Component
const ToastNotification = ({ toast, setToast, translations }) => {
    const getIconForType = (type) => {
        switch (type) {
            case 'success':
                return faCheckCircle;
            case 'error':
                return faExclamationTriangle;
            case 'warning':
                return faExclamationTriangle;
            default:
                return faCheckCircle;
        }
    };

    const getTitleForType = (type) => {
        switch (type) {
            case 'success':
                return translations.success || 'Success';
            case 'error':
                return translations.error || 'Error';
            case 'warning':
                return translations.warning || 'Warning';
            default:
                return '';
        }
    };

    if (!toast.show) return null;

    return (
        <div 
            className={`toast-notification ${toast.type} ${toast.direction === 'rtl' ? 'toast-rtl' : 'toast-ltr'}`}
            style={{ direction: toast.direction }}
        >
            <div className="toast-content">
                <div className="toast-icon">
                    <FontAwesomeIcon icon={getIconForType(toast.type)} />
                </div>
                <div className="toast-text">
                    <div className="toast-title">
                        {getTitleForType(toast.type)}
                    </div>
                    <div className="toast-message">
                        {toast.message}
                    </div>
                </div>
                <button 
                    className="toast-close"
                    onClick={() => setToast(prev => ({ ...prev, show: false }))}
                >
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </div>
            <div className="toast-timer">
                <div 
                    className="toast-progress-bar"
                    style={{ width: `${toast.progress}%` }}
                ></div>
            </div>
        </div>
    );
};

// Shop Selector Modal Component
const ShopSelectorModal = ({ isOpen, onClose, shops, currentShop, onSelectShop, translations, loading }) => {
    if (!isOpen) return null;

    const handleShopSelect = (shop) => {
        onSelectShop(shop);
        onClose();
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content shop-selector-modal">
                <div className="modal-header">
                    <h3>{translations.switchShop || 'Switch Shop'}</h3>
                    <button className="modal-close" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                <div className="modal-body">
                    {loading ? (
                        <div className="loading-shops">
                            <div className="loading-spinner-small"></div>
                            <p>{translations.loadingShops || 'Loading shops...'}</p>
                        </div>
                    ) : shops.length === 0 ? (
                        <div className="no-shops">
                            <p>{translations.noShops || 'No shops available'}</p>
                        </div>
                    ) : (
                        <div className="shop-list">
                            {shops.map((shop) => (
                                <div 
                                    key={shop.shop_id}
                                    className={`shop-item ${currentShop?.shop_id === shop.shop_id ? 'active' : ''}`}
                                    onClick={() => handleShopSelect(shop)}
                                >
                                    <div className="shop-item-icon">
                                        <FontAwesomeIcon icon={faStore} />
                                    </div>
                                    <div className="shop-item-details">
                                        <div className="shop-item-name">{shop.shop_name}</div>
                                        <div className="shop-item-code">{shop.shop_code || `ID: ${shop.shop_id}`}</div>
                                    </div>
                                    {currentShop?.shop_id === shop.shop_id && (
                                        <div className="shop-item-current">
                                            <FontAwesomeIcon icon={faCheckCircle} />
                                            <span>{translations.current || 'Current'}</span>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const AddProduct = ({ productId = null, onSuccess = null }) => {
    const { user, currentShop, switchShop, getShopsForSwitch } = useAuth();
    
    // Get language from user object or localStorage
    const [currentLanguage, setCurrentLanguage] = useState(() => {
        return user?.language || localStorage.getItem('ourzest_language') || 'en';
    });
    
    const [formData, setFormData] = useState({
        date: new Date().toISOString().split('T')[0],
        batch_no: '',
        barcode: '',
        product_name: '',
        category: '',
        company: '',
        unit: '',
        cost_price: '',
        sell_price: '',
        quantity: '',
        quantity_alert: '',
        expiry_date: '',
        stock_category: 'Saleable',
        themeColor: localStorage.getItem('ourzest_theme') || '#6366f1'
    });
    
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [translations, setTranslations] = useState({});
    
    // Toast state
    const [toast, setToast] = useState({
        show: false,
        type: '',
        message: '',
        direction: 'ltr',
        progress: 100,
        timeLeft: 3
    });
    
    // Shop selector state
    const [showShopSelector, setShowShopSelector] = useState(false);
    const [availableShops, setAvailableShops] = useState([]);
    const [loadingShops, setLoadingShops] = useState(false);
    
    // Submission control refs
    const isSubmittingRef = useRef(false);
    const submissionLockRef = useRef(false);
    const lastSubmissionRef = useRef(null);
    const toastTimerRef = useRef(null);
    const formRef = useRef(null);
    const abortControllerRef = useRef(null);

    // Stock category options
    const stockCategories = [
        { value: '', label: 'selectstockCategory' },
        { value: 'Saleable', label: 'saleable' },
        { value: 'Raw', label: 'raw' }
    ];

    // Categories and units
    const categories = [
        { value: '', label: 'selectCategory' },
        { value: 'food', label: 'food' },
        { value: 'other', label: 'other' }
    ];
    
    const units = [
        { value: '', label: 'selectUnit' },
        { value: 'piece', label: 'piece' },
        { value: 'box', label: 'box' },
        { value: 'packet', label: 'packet' },
        { value: 'kg', label: 'kg' },
        { value: 'gram', label: 'gram' },
        { value: 'liter', label: 'liter' },
        { value: 'ml', label: 'ml' },
        { value: 'dabba', label: 'dabba' },
        { value: 'burai', label: 'burai' },
        { value: 'dozen', label: 'dozen' }
    ];

    // Show toast
    const showToast = (type, message) => {
        if (toastTimerRef.current) {
            clearInterval(toastTimerRef.current);
        }
        
        const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar' || currentLanguage === 'ps' || currentLanguage === 'fa';
        
        setToast({
            show: true,
            type,
            message,
            direction: isRTL ? 'rtl' : 'ltr',
            progress: 100,
            timeLeft: 3
        });

        let timeLeft = 3;
        const timer = setInterval(() => {
            timeLeft -= 0.1;
            setToast(prev => ({
                ...prev,
                progress: (timeLeft / 3) * 100,
                timeLeft: parseFloat(timeLeft.toFixed(1))
            }));

            if (timeLeft <= 0) {
                clearInterval(timer);
                setToast(prev => ({ ...prev, show: false }));
            }
        }, 100);

        toastTimerRef.current = timer;
    };

    // Cleanup
    useEffect(() => {
        return () => {
            if (toastTimerRef.current) clearInterval(toastTimerRef.current);
            if (abortControllerRef.current) abortControllerRef.current.abort();
            isSubmittingRef.current = false;
            submissionLockRef.current = false;
        };
    }, []);

    // Sync language from user
    useEffect(() => {
        if (user?.language && user.language !== currentLanguage) {
            setCurrentLanguage(user.language);
        }
    }, [user?.language]);

    // Listen for language change events
    useEffect(() => {
        const handleLanguageChange = (e) => {
            if (e.detail?.language) {
                setCurrentLanguage(e.detail.language);
            }
        };

        window.addEventListener('languagechange', handleLanguageChange);
        return () => window.removeEventListener('languagechange', handleLanguageChange);
    }, []);

    // Storage event listener
    useEffect(() => {
        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_language') {
                setCurrentLanguage(e.newValue || 'en');
            }
        };
        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, []);

    // Load translations
    useEffect(() => {
        const loadTranslations = async () => {
            const trans = await productsTranslator.getTranslations(currentLanguage);
            setTranslations(trans);
        };
        loadTranslations();
    }, [currentLanguage]);

    // Load product data for edit
    useEffect(() => {
        if (productId) {
            setIsEditMode(true);
            loadProductData(productId);
        }
    }, [productId]);

    // Generate barcode
    useEffect(() => {
        if (formData.batch_no && !isEditMode && currentShop) {
            generateBarcode();
        }
    }, [formData.batch_no, isEditMode, currentShop]);

    // Load shops
    useEffect(() => {
        const loadAvailableShops = async () => {
            if (!user) return;
            setLoadingShops(true);
            try {
                const shopsData = await getShopsForSwitch();
                setAvailableShops(shopsData.shops || []);
            } catch (error) {
                console.error('Error loading shops:', error);
                setAvailableShops([]);
            } finally {
                setLoadingShops(false);
            }
        };
        loadAvailableShops();
    }, [user, getShopsForSwitch]);

    // Apply RTL/LTR to all elements
    useEffect(() => {
        const rtlLanguages = ['ur', 'ar', 'ps', 'fa', 'he'];
        const isRTL = rtlLanguages.includes(currentLanguage);
        
        document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
        document.documentElement.lang = currentLanguage;
        document.body.dir = isRTL ? 'rtl' : 'ltr';
        
        const mainContainer = document.querySelector('.customer-form-independent');
        if (mainContainer) {
            if (isRTL) {
                mainContainer.classList.add('rtl');
            } else {
                mainContainer.classList.remove('rtl');
            }
        }
        
        document.querySelectorAll('input, select, textarea').forEach(input => {
            if (input && !input.classList.contains('no-rtl')) {
                input.style.textAlign = isRTL ? 'right' : 'left';
            }
        });
        
    }, [currentLanguage]);

    // Validate form - Updated to handle selling price based on stock category
    const validateForm = () => {
        const newErrors = {};
        
        if (!formData.product_name?.trim()) {
            newErrors.product_name = translations.nameRequired || 'Product name is required';
        } else if (formData.product_name.trim().length < 2) {
            newErrors.product_name = translations.nameTooShort || 'Name must be at least 2 characters';
        }
        
        if (!formData.batch_no?.trim()) {
            newErrors.batch_no = translations.batchRequired || 'Batch number is required';
        }
        
        if (!formData.unit) {
            newErrors.unit = translations.unitRequired || 'Unit is required';
        }
        
        if (!formData.cost_price || parseFloat(formData.cost_price) <= 0) {
            newErrors.cost_price = translations.costPriceRequired || 'Cost price is required';
        }
        
        // Only validate selling price if stock category is Saleable
        if (formData.stock_category === 'Saleable') {
            if (!formData.sell_price || parseFloat(formData.sell_price) <= 0) {
                newErrors.sell_price = translations.sellingPriceRequired || 'Selling price is required';
            }
        }
        
        if (!formData.quantity || parseFloat(formData.quantity) < 0) {
            newErrors.quantity = translations.quantityRequired || 'Quantity is required';
        }
        
        if (!formData.quantity_alert || parseFloat(formData.quantity_alert) < 0) {
            newErrors.quantity_alert = translations.alertRequired || 'Low stock alert quantity is required';
        }
        
        if (formData.expiry_date) {
            const expiry = new Date(formData.expiry_date);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            if (expiry < today) {
                newErrors.expiry_date = translations.expiryPast || 'Expiry date cannot be in the past';
            }
        }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Handle submit
    const handleSubmit = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!currentShop) {
            showToast('error', translations.selectShop || 'Please select a shop first');
            setShowShopSelector(true);
            return;
        }
        
        if (!validateForm()) return;
        
        if (isSubmittingRef.current || submissionLockRef.current) {
            showToast('warning', 'Please wait, submission in progress...');
            return;
        }

        const now = Date.now();
        if (lastSubmissionRef.current) {
            const timeDiff = now - lastSubmissionRef.current.time;
            const dataMatch = JSON.stringify(formData) === lastSubmissionRef.current.data;
            
            if (timeDiff < 3000 && dataMatch) {
                showToast('warning', 'Please wait before submitting again');
                return;
            }
        }

        isSubmittingRef.current = true;
        submissionLockRef.current = true;
        setLoading(true);
        
        lastSubmissionRef.current = {
            time: now,
            data: JSON.stringify(formData)
        };

        abortControllerRef.current = new AbortController();

        try {
            const currentUsername = user?.username || 'Unknown';
            
            const productData = {
                action: isEditMode ? 'edit' : 'add',
                ...formData,
                username: currentUsername,
                shop_id: currentShop.shop_id,
                submission_timestamp: now
            };
            
            if (isEditMode && productId) {
                productData.id = productId;
            }
            
            const response = await fetch('https://ourzestapp.online/oz_backend/products.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(productData),
                signal: abortControllerRef.current.signal
            });

            const data = await response.json();

            if (data.status === 'success') {
                showToast('success', isEditMode 
                    ? (translations.productUpdated || 'Product updated successfully!')
                    : (translations.productSaved || 'Product saved successfully!'));
                
                if (!isEditMode) {
                    setFormData({
                        date: new Date().toISOString().split('T')[0],
                        batch_no: '',
                        barcode: '',
                        product_name: '',
                        category: '',
                        company: '',
                        unit: '',
                        cost_price: '',
                        sell_price: '',
                        quantity: '',
                        quantity_alert: '',
                        expiry_date: '',
                        stock_category: 'Saleable',
                        themeColor: formData.themeColor
                    });
                    setErrors({});
                }
                
                if (onSuccess) onSuccess(data.productid || productId);
            } else {
                showToast('error', data.message || (isEditMode 
                    ? translations.failedUpdate 
                    : translations.failedAdd) || 'Operation failed');
            }
        } catch (error) {
            if (error.name !== 'AbortError') {
                showToast('error', error.message || translations.networkError || 'Network error');
            }
        } finally {
            setTimeout(() => {
                isSubmittingRef.current = false;
                submissionLockRef.current = false;
                setLoading(false);
                abortControllerRef.current = null;
            }, 1000);
        }
    };

    // Handle input change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
    };

    const handleClear = () => {
        setFormData({
            date: new Date().toISOString().split('T')[0],
            batch_no: '',
            barcode: '',
            product_name: '',
            category: '',
            company: '',
            unit: '',
            cost_price: '',
            sell_price: '',
            quantity: '',
            quantity_alert: '',
            expiry_date: '',
            stock_category: 'Saleable',
            themeColor: formData.themeColor
        });
        setErrors({});
        setIsEditMode(false);
        lastSubmissionRef.current = null;
    };

    const handleSwitchShop = async (shop) => {
        try {
            const success = await switchShop(shop.shop_id, shop.shop_name, shop.shop_code);
            showToast(success ? 'success' : 'error', 
                success ? (translations.shopSwitched || 'Shop switched successfully')
                       : (translations.shopSwitchFailed || 'Failed to switch shop'));
        } catch (error) {
            showToast('error', translations.shopSwitchFailed || 'Failed to switch shop');
        }
    };

    const generateBarcode = () => {
        if (!formData.batch_no || !user?.username || !currentShop) return;
        
        const shopPrefix = currentShop.shop_id.toString().substring(0, 2).replace(/[^0-9]/g, '0');
        const userPrefix = user.username.substring(0, 3).toUpperCase().replace(/[^A-Z0-9]/g, 'P');
        const timestamp = Date.now().toString().substring(7);
        const batchHash = btoa(formData.batch_no).substring(0, 5).replace(/[^A-Z0-9]/g, '');
        
        setFormData(prev => ({ ...prev, barcode: `${shopPrefix}${userPrefix}${timestamp}${batchHash}` }));
    };

    const loadProductData = async (id) => {
        if (!currentShop) {
            showToast('error', translations.selectShop || 'Please select a shop first');
            setShowShopSelector(true);
            return;
        }

        setLoading(true);
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/products.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_record',
                    id: id,
                    username: user?.username,
                    shop_id: currentShop.shop_id
                })
            });

            const data = await response.json();
            
            if (data.status === 'success' && data.data) {
                setFormData(prev => ({
                    ...prev,
                    ...data.data,
                    themeColor: prev.themeColor
                }));
            } else {
                showToast('error', data.message || 'Failed to load product data');
            }
        } catch (error) {
            showToast('error', translations.networkError || 'Network error');
        } finally {
            setLoading(false);
        }
    };

    const calculateProfitMargin = () => {
        const cost = parseFloat(formData.cost_price) || 0;
        const selling = parseFloat(formData.sell_price) || 0;
        
        // Only calculate profit margin for Saleable products with valid selling price
        if (formData.stock_category === 'Saleable' && cost > 0 && selling > cost) {
            const margin = ((selling - cost) / selling) * 100;
            const markup = ((selling - cost) / cost) * 100;
            return { margin: margin.toFixed(2), markup: markup.toFixed(2) };
        }
        return { margin: '0.00', markup: '0.00' };
    };

    // Apply theme
    useEffect(() => {
        const applyTheme = (color) => {
            try {
                if (!/^#[0-9A-F]{6}$/i.test(color)) color = '#6366f1';
                
                const hex = color.replace('#', '');
                const r = parseInt(hex.substring(0, 2), 16);
                const g = parseInt(hex.substring(2, 4), 16);
                const b = parseInt(hex.substring(4, 6), 16);

                const adjust = (amount) => {
                    let newR = Math.max(0, Math.min(255, r + amount));
                    let newG = Math.max(0, Math.min(255, g + amount));
                    let newB = Math.max(0, Math.min(255, b + amount));
                    return `#${newR.toString(16).padStart(2, '0')}${newG.toString(16).padStart(2, '0')}${newB.toString(16).padStart(2, '0')}`;
                };

                const palette = {
                    'customer-primary-color': color,
                    'customer-primary-dark': adjust(-40),
                    'customer-primary-light': adjust(40),
                    'customer-primary-ultralight': adjust(20),
                    'customer-primary-gradient': `linear-gradient(135deg, ${color}, ${adjust(-20)})`,
                    'customer-primary-shadow': `${color}20`
                };

                Object.entries(palette).forEach(([key, value]) => {
                    document.documentElement.style.setProperty(`--${key}`, value);
                });
            } catch (err) {
                console.error("Error applying theme:", err);
            }
        };

        applyTheme(formData.themeColor);

        const handleThemeChange = () => {
            const theme = localStorage.getItem('ourzest_theme') || '#6366f1';
            if (theme !== formData.themeColor) {
                setFormData(prev => ({ ...prev, themeColor: theme }));
                applyTheme(theme);
            }
        };

        window.addEventListener('storage', handleThemeChange);
        return () => window.removeEventListener('storage', handleThemeChange);
    }, [formData.themeColor]);

    const { margin, markup } = calculateProfitMargin();
    const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar' || currentLanguage === 'ps' || currentLanguage === 'fa';
    
    // Check if selling price is required based on stock category
    const isSellingPriceRequired = formData.stock_category === 'Saleable';

    const renderShopIndicator = () => {
        if (!currentShop) {
            return (
                <div className="shop-indicator-modern no-shop">
                    <div className="shop-badge">
                        <FontAwesomeIcon icon={faExclamationTriangle} />
                        <span>{translations.noShopSelected || 'No shop selected'}</span>
                    </div>
                    <button 
                        className="btn-modern btn-switch-shop"
                        onClick={() => setShowShopSelector(true)}
                        type="button"
                    >
                        <FontAwesomeIcon icon={faExchangeAlt} />
                        <span>{translations.switchShop || 'Switch Shop'}</span>
                    </button>
                </div>
            );
        }
    };

    return (
        <div className={`customer-form-independent ${isRTL ? 'rtl' : ''}`}>
            <ToastNotification toast={toast} setToast={setToast} translations={translations} />

            <ShopSelectorModal
                isOpen={showShopSelector}
                onClose={() => setShowShopSelector(false)}
                shops={availableShops}
                currentShop={currentShop}
                onSelectShop={handleSwitchShop}
                translations={translations}
                loading={loadingShops}
            />

            <div className="form-header-modern">
                <div className="header-content">
                    <div className="header-icon">
                        <FontAwesomeIcon icon={faBox} />
                    </div>
                    <div className="header-text">
                        <h1>{isEditMode ? translations.editProduct : translations.addProduct}</h1>
                        <p>{translations.fillDetails}</p>
                    </div>
                </div>
                {renderShopIndicator()}
            </div>

            <form ref={formRef} onSubmit={handleSubmit} className="modern-form">
                <div className="form-grid-modern">
                    {/* Date Field */}
                    <div className={`form-group-modern ${errors.date ? 'has-error' : ''}`}>
                        <div className="input-container">
                            <FontAwesomeIcon icon={faCalendarAlt} className="input-icon" />
                            <input
                                type="date"
                                name="date"
                                value={formData.date}
                                onChange={handleChange}
                                disabled={loading}
                                className="no-rtl"
                            />
                            <label className="input-label">{translations.date}</label>
                        </div>
                        {errors.date && <div className="error-message-modern">{errors.date}</div>}
                    </div>

                    {/* Product Name */}
                    <div className={`form-group-modern ${errors.product_name ? 'has-error' : ''}`}>
                        <div className="input-container">
                            <FontAwesomeIcon icon={faBox} className="input-icon" />
                            <input
                                type="text"
                                name="product_name"
                                value={formData.product_name}
                                onChange={handleChange}
                                required
                                placeholder={translations.enterProductName || 'Enter product name'}
                                disabled={loading}
                            />
                            <label className="input-label">
                                {translations.productName} <span className="required">*</span>
                            </label>
                        </div>
                        {errors.product_name && <div className="error-message-modern">{errors.product_name}</div>}
                    </div>

                    {/* Batch Number */}
                    <div className={`form-group-modern ${errors.batch_no ? 'has-error' : ''}`}>
                        <div className="input-container">
                            <FontAwesomeIcon icon={faTag} className="input-icon" />
                            <input
                                type="text"
                                name="batch_no"
                                value={formData.batch_no}
                                onChange={handleChange}
                                required
                                placeholder={translations.enterBatchNumber || 'Enter batch number'}
                                disabled={loading || isEditMode}
                            />
                            <label className="input-label">
                                {translations.batchNumber} <span className="required">*</span>
                            </label>
                        </div>
                        {errors.batch_no && <div className="error-message-modern">{errors.batch_no}</div>}
                    </div>

                    {/* Barcode */}
                    <div className="form-group-modern">
                        <div className="input-container">
                            <FontAwesomeIcon icon={faBarcode} className="input-icon" />
                            <input
                                type="text"
                                name="barcode"
                                value={formData.barcode}
                                readOnly
                                placeholder={translations.barcodeAutoGenerate || 'Barcode will auto-generate'}
                                disabled
                                className="no-rtl"
                            />
                            <label className="input-label">{translations.barcode}</label>
                        </div>
                    </div>

                    {/* Stock Category */}
                    <div className="form-group-modern">
                        <div className="input-container">
                            <FontAwesomeIcon icon={faLayerGroup} className="input-icon" />
                            <select
                                name="stock_category"
                                value={formData.stock_category}
                                onChange={handleChange}
                                disabled={loading}
                                className="stock-category-select"
                            >
                                {stockCategories.map(cat => (
                                    <option key={cat.value} value={cat.value}>
                                        {translations[cat.label] || cat.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Category */}
                    <div className="form-group-modern">
                        <div className="input-container">
                            <FontAwesomeIcon icon={faTag} className="input-icon" />
                            <select
                                name="category"
                                value={formData.category}
                                onChange={handleChange}
                                disabled={loading}
                            >
                                {categories.map(cat => (
                                    <option key={cat.value} value={cat.value}>
                                        {translations[cat.label] || cat.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Company */}
                    <div className="form-group-modern">
                        <div className="input-container">
                            <FontAwesomeIcon icon={faBuilding} className="input-icon" />
                            <input
                                type="text"
                                name="company"
                                value={formData.company}
                                onChange={handleChange}
                                placeholder={translations.enterCompany || 'Enter company/brand'}
                                disabled={loading}
                            />
                            <label className="input-label">{translations.company}</label>
                        </div>
                    </div>

                    {/* Unit */}
                    <div className={`form-group-modern ${errors.unit ? 'has-error' : ''}`}>
                        <div className="input-container">
                            <FontAwesomeIcon icon={faBalanceScale} className="input-icon" />
                            <select
                                name="unit"
                                value={formData.unit}
                                onChange={handleChange}
                                required
                                disabled={loading}
                            >
                                {units.map(unit => (
                                    <option key={unit.value} value={unit.value}>
                                        {translations[unit.label] || unit.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {errors.unit && <div className="error-message-modern">{errors.unit}</div>}
                    </div>

                    {/* Cost Price */}
                    <div className={`form-group-modern ${errors.cost_price ? 'has-error' : ''}`}>
                        <div className="input-container">
                            <FontAwesomeIcon icon={faDollarSign} className="input-icon" />
                            <input
                                type="number"
                                name="cost_price"
                                value={formData.cost_price}
                                onChange={handleChange}
                                required
                                step="0.01"
                                min="0"
                                placeholder={translations.zeroPlaceholderDecimal || '0.00'}
                                disabled={loading}
                                className="no-rtl"
                            />
                            <label className="input-label">
                                {translations.costPrice} <span className="required">*</span>
                            </label>
                        </div>
                        {errors.cost_price && <div className="error-message-modern">{errors.cost_price}</div>}
                    </div>

                    {/* Selling Price - Now optional for Raw products */}
                    <div className={`form-group-modern ${errors.sell_price ? 'has-error' : ''}`}>
                        <div className="input-container">
                            <FontAwesomeIcon icon={faDollarSign} className="input-icon" />
                            <input
                                type="number"
                                name="sell_price"
                                value={formData.sell_price}
                                onChange={handleChange}
                                required={isSellingPriceRequired}
                                step="0.01"
                                min="0"
                                placeholder={translations.zeroPlaceholderDecimal || '0.00'}
                                disabled={loading}
                                className="no-rtl"
                            />
                            <label className="input-label">
                                {translations.sellingPrice}
                                {isSellingPriceRequired ? <span className="required">*</span> : <span className="optional"> ({translations.optional})</span>}
                            </label>
                        </div>
                        {errors.sell_price && <div className="error-message-modern">{errors.sell_price}</div>}
                    </div>

                    {/* Profit Margin Display - Only show for Saleable products with valid selling price */}
                    {formData.stock_category === 'Saleable' && parseFloat(formData.sell_price) > 0 && parseFloat(formData.cost_price) > 0 && (
                        <div className="form-group-modern">
                            <div className="calculation-display">
                                <div className="calculation-item">
                                    <FontAwesomeIcon icon={faCalculator} />
                                    <span>{translations.profitMargin}:</span>
                                    <span className={parseFloat(margin) > 0 ? 'positive' : ''}>{margin}%</span>
                                </div>
                                <div className="calculation-item">
                                    <FontAwesomeIcon icon={faPercent} />
                                    <span>{translations.markup}:</span>
                                    <span className={parseFloat(markup) > 0 ? 'positive' : ''}>{markup}%</span>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Quantity */}
                    <div className={`form-group-modern ${errors.quantity ? 'has-error' : ''}`}>
                        <div className="input-container">
                            <FontAwesomeIcon icon={faWarehouse} className="input-icon" />
                            <input
                                type="number"
                                name="quantity"
                                value={formData.quantity}
                                onChange={handleChange}
                                required
                                step="0.001"
                                min="0"
                                placeholder={translations.zeroPlaceholderThreeDecimal || '0.000'}
                                disabled={loading}
                                className="no-rtl"
                            />
                            <label className="input-label">
                                {translations.quantity} <span className="required">*</span>
                            </label>
                        </div>
                        {errors.quantity && <div className="error-message-modern">{errors.quantity}</div>}
                    </div>

                    {/* Low Stock Alert */}
                    <div className={`form-group-modern ${errors.quantity_alert ? 'has-error' : ''}`}>
                        <div className="input-container">
                            <FontAwesomeIcon icon={faExclamationTriangle} className="input-icon" />
                            <input
                                type="number"
                                name="quantity_alert"
                                value={formData.quantity_alert}
                                onChange={handleChange}
                                required
                                step="0.001"
                                min="0"
                                placeholder={translations.zeroPlaceholderThreeDecimal || '0.000'}
                                disabled={loading}
                                className="no-rtl"
                            />
                            <label className="input-label">
                                {translations.quantityAlert} <span className="required">*</span>
                            </label>
                        </div>
                        {errors.quantity_alert && <div className="error-message-modern">{errors.quantity_alert}</div>}
                    </div>

                    {/* Expiry Date */}
                    <div className={`form-group-modern ${errors.expiry_date ? 'has-error' : ''}`}>
                        <div className="input-container">
                            <FontAwesomeIcon icon={faCalendarAlt} className="input-icon" />
                            <input
                                type="date"
                                name="expiry_date"
                                value={formData.expiry_date}
                                onChange={handleChange}
                                disabled={loading}
                                className="no-rtl"
                            />
                            <label className="input-label">
                                {translations.expiryDate}
                                <span className="optional"> ({translations.optional})</span>
                            </label>
                        </div>
                        {errors.expiry_date && <div className="error-message-modern">{errors.expiry_date}</div>}
                    </div>
                </div>

                {/* Form Actions */}
                <div className="form-actions-modern">
                    <button type="button" className="btn-modern btn-secondary-modern" onClick={handleClear} disabled={loading}>
                        <FontAwesomeIcon icon={faTimes} />
                        <span>{translations.clearButton}</span>
                    </button>
                    <button type="submit" className="btn-modern btn-primary-modern" disabled={loading || !currentShop || isSubmittingRef.current}>
                        {loading || isSubmittingRef.current ? (
                            <>
                                <div className="btn-spinner"></div>
                                <span>{isEditMode ? translations.updating : translations.adding}</span>
                            </>
                        ) : (
                            <>
                                <span>{isEditMode ? translations.updateProduct : translations.addProductButton}</span>
                                <FontAwesomeIcon icon={faSave} />
                            </>
                        )}
                    </button>
                </div>
            </form>

             {/* Loading Overlay */}
            {loading && (
                <div className="loading-overlay">
                    <div className="loading-content">
                        <div className="loading-spinner"></div>
                        <p>{translations.adding || 'Adding...'}</p>
                        <p className="loading-subtext">Please wait while we add product data</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AddProduct;